import { browserHistory } from 'init/redux-store';
import qs from 'query-string';
import { mapKeys } from 'remeda';

export const animationClassList = (name: string, styles: Function) => ({
  appear: styles(`${name}-appear`),
  appearActive: styles(`${name}-appear-active`),
  enter: styles(`${name}-enter`),
  enterActive: styles(`${name}-enter-active`),
  enterDone: styles(`${name}-enter-done`),
  exit: styles(`${name}-exit`),
  exitActive: styles(`${name}-exit-active`),
  exitDone: styles(`${name}-exit-done`),
});

export default animationClassList;

// Only used once
export function downloadBlobFile(blobURL: string, filename: string, blob?: unknown) {
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    // IE workaround for "HTML7007: One or more blob URLs were
    // revoked by closing the blob for which they were created.
    // These URLs will no longer resolve as the data backing
    // the URL has been freed."
    if (blob) {
      window.navigator.msSaveBlob(blob, filename);
    } else {
      fetch(blobURL)
        .then(res => res.blob())
        .then(resBlob => {
          window.navigator.msSaveBlob!(resBlob, filename);
        });
    }
  } else {
    const tempLink = document.createElement('a');
    tempLink.style.display = 'none';
    tempLink.href = blobURL;
    tempLink.setAttribute('download', filename);

    // Safari thinks _blank anchor are pop ups. We only want to set _blank
    // target if the browser does not support the HTML5 download attribute.
    // This allows you to download files in desktop safari if pop up blocking
    // is enabled.

    if (typeof tempLink.download === 'undefined') {
      tempLink.setAttribute('target', '_blank');
    }

    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
  }
}

/**
 * Download a file from an api
 */
export function downloadFile(data: any, filename: string, mime?: string) {
  const blob = new Blob([data], { type: mime || 'application/octet-stream' });
  const blobUrl = window.URL.createObjectURL(blob);
  downloadBlobFile(blobUrl, filename, blob);
  window.URL.revokeObjectURL(blobUrl);
}

export const extractFilename = (headers: any) => {
  const disposition = headers['content-disposition'];
  let filename = disposition.match('filename="(.*)"');
  filename = filename?.[1];

  return filename;
};

export const removeAttributes = (item: any) => {
  item = {
    ...item,
    ...item.attributes,
  };
  delete item.attributes;
  return item;
};

// Only used twice, easy to replace
export const updateQueryFilters = (queryStrings: any) => {
  browserHistory.push({
    pathname: location.pathname,
    search: qs.stringify(queryStrings, { arrayFormat: 'comma' }),
  });
};

export const reducerState = (prevState: any, updatedProperty: any) => ({
  ...prevState,
  ...updatedProperty,
});

const BANKS = {
  ARSPBE22: 'argenta.png',
  AXABBE22: 'axa.png',
  GKCCBEBB: 'belfius.png',
  CTBKBEBX: 'beobank.png',
  GEBABEBB: 'bnp.png',
  BPOTBEB1: 'bpost.png',
  CREGBEBB: 'cbc.png',
  CEKVBE81: 'ckv.png',
  NICABEBB: 'crelan.png',
  DEUTBEBE: 'deutschebank.png',
  EURBBE99: 'europabank.png',
  BBRUBEBB: 'ing.png',
  KREDBEBB: 'kbc.png',
  SGPBBE99: 'societe-generale.png',
  TRIOBEBB: 'triodos.png',
} as const;

export const getBankImage = async (bic: keyof typeof BANKS) => {
  if (BANKS[bic]) {
    const imageModule = await import(/* @vite-ignore */ `./assets/bank/${BANKS[bic]}`);
    return imageModule.default;
  }

  return null;
};

export const queryParamParser = (value: any) => {
  Object.keys(value).forEach(key => {
    if (key.indexOf('_start') !== -1) {
      const fieldName = key.substring(0, key.indexOf('_start'));
      value[fieldName] = [value[`${fieldName}_start`] || null, value[`${fieldName}_end`] || null];
    } else if (key.indexOf('_end') !== -1) {
      const fieldName = key.substring(0, key.indexOf('_end'));
      value[fieldName] = [value[`${fieldName}_start`] || null, value[`${fieldName}_end`] || null];
    }
  });

  return mapKeys(value, k => String(k).replace('?', ''));
};
